import React from 'react';
import I18n from 'i18n-js';

import BottomPopupButton, { SIDES } from '~/components/BottomPopupButton';
import { ESuffix } from '~/components/CardsShredPopup/ESuffix';

import CoinsIcon from '~/assets/images/currencies/Coin Front.png';

import styles from './Footer.module.scss';

export interface ICardsShredPopupFooter {
  bonus: number;
  shredCards: () => void;
  cancelShredding: () => void;
  suffix: ESuffix;
}

const Footer: React.FC<ICardsShredPopupFooter> = ({
  bonus,
  cancelShredding,
  shredCards,
  suffix = ESuffix.singular,
}) => {
  return (
    <section className={styles.footer}>
      <p className={styles.bonusSection}>
        <span className={styles.bonusTitle}>
          {I18n.t('CardDetailView_confirm_shred_get')}
        </span>
        <span className={styles.bonusCount}>
          {bonus}
          <img
            src={CoinsIcon}
            alt="coins-icon"
            className={styles.lootIcon}
          />
        </span>
      </p>
      <section className={styles.buttonsSection}>
        <BottomPopupButton
          side={SIDES.LEFT}
          onClick={cancelShredding}
          className={styles.leftButton}
          divider={undefined}
          dividerClassName={undefined}
        >
          {I18n.t(`CardDetailView_confirm_shred_no${suffix}`)}
        </BottomPopupButton>
        <BottomPopupButton
          side={SIDES.RIGHT}
          divider={undefined}
          onClick={shredCards}
          className={styles.rightButton}
          dividerClassName={undefined}
        >
          {I18n.t(`CardDetailView_confirm_shred_yes${suffix}`)}
        </BottomPopupButton>
      </section>
    </section>
  );
};

export default Footer;
